(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/unionWith', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/unionWith'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.unionWith, global.convert);
    global.unionWith = mod.exports;
  }
})(this, function (exports, _unionWith2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.unionWith = undefined;

  var _unionWith3 = _interopRequireDefault(_unionWith2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.union} except that it accepts <code>comparator</code> to compare elements.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @param {Function} [comparator] The comparator invoked per element.
   * @return {Object} Returns the updated object.
   * @example unionWith({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], (a, b) => a.x === b.x) // => { nested: { prop: [{ x: 1 }, { x: 2 }, { x: 3 }] } }
   * @see {@link https://lodash.com/docs#unionWith|lodash.unionWith} for more information.
   * @since 0.3.0
   */
  var unionWith = (0, _convert.convert)(_unionWith3.default);
  exports.unionWith = unionWith;
  exports.default = unionWith;
});